import { makeStyles } from '@material-ui/core';
import tw from 'twin.macro';

export default makeStyles(() => ({
  root: {
    '&': tw`bg-gray-300 flex items-center justify-center`,
  },
  /** Align info icon superscript with adjacent text (1px nudge; Tailwind v1 has no `top-px`). */
  hotelUnavailInfoSup: {
    position: 'relative',
    top: -1,
  },
}));
